import { ConfigRepo } from '../repos/ConfigRepo';

export const useConfigRepo = () => {
  const configRepo = new ConfigRepo(process.env);
  return { configRepo };
};
